import { autoinject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import { SessionManager } from '../../services/session-manager';
import { I18N } from 'aurelia-i18n';

@autoinject
export class My401Page {
	portalUrl: string;
	linkText: string;
	portalLink: string;

	constructor(state: State, private i18n:I18N, sessionManager: SessionManager) {
		console.log(state.business.portalSettings);
		this.portalUrl = state.business.portalSettings.url;
		sessionManager.endSession();
		this.linkText = `<a href="${this.portalUrl}">${this.i18n.i18next.t('returnToPortal', 'Return to the portal')}</a>`;
		this.portalLink = this.i18n.i18next.t('youCanLogInAgainHere', {
			defaultValue: `You can log in again and continue using the portal here: ${this.linkText}`, link: this.linkText
		});
	}

	attached() {
		setTimeout(() => {
			let announcement = document.querySelector('#announcementContainer') as HTMLElement;
			announcement.focus();
		}, 200);
	}
}
